import React, {useEffect} from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {ErrorMessage, Field, Formik} from "formik";
import * as Yup from "yup";
import {loadUsers} from "../../../user/usersAction";
import {CLEAR_PROJECT} from "../../../project/actionsType";
import Assistant from "../../Assistant";
import {FormFormik, InputTextFormik} from "../../../inputs/InputStyle";
import TextareaFormikInput from "../../../inputs/TextareaFormikInput";
import TagInput from "../../../inputs/TagInput";
import SelectUserInputFormik from "../../../inputs/SelectUserInputFormik";
import SendFormButton from "../../../buttons/SendFormButton";
import {postProject} from "../../../project/one-project/projectAction";
import {STRATEGY_ABSOLUTE_ROUTE} from "../../../../routes/routesName";
import {loadOneAxis} from "../../../axis/one-axis/oneAxisAction";
import {loadProjects} from "../../../project/projects/projectsAction";
import {BaseModal} from "../../../modal/modalStyle";
import useTags from "../../../../custom-hooks/useTags";

const ProjectFormForCoach = ({ setOpenModal, stakeId = null, close,projectFromCoach }) => {
    const { selectedTags, setSelectedTags } = useTags(null, null);

    const location = useLocation();
    const dispatch = useDispatch();
    const {
        id: axisId,
        swots: axisSwot,
        isStrategic,
    } = useSelector((state) => state.oneAxis);
    const { name: stakeName } = useSelector((state) => state.oneStake);

    const { id: currentUserId } = useSelector((state) => state.currentUser);
    const { users } = useSelector((state) => state.users);

    useEffect(() => {
        dispatch(loadUsers());
    }, [dispatch]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_PROJECT });
        };
    }, [dispatch]);

    const handleSubmit = async (data) => {
        const newData = Object.assign({}, data);
        newData.pilotId = Number(data.pilotId);
        newData.isStrategic = isStrategic;
        newData.stakeId = stakeId;
        newData.isTimeSpentOptional = true;
        newData.isBudgetOptional = true;

        if (selectedTags.length > 0) {
            let tagsSelected = [];
            selectedTags.forEach((tag) => {
                tagsSelected.push({ tagId: tag.id });
            });
            newData.tags = tagsSelected;
        }

        await dispatch(postProject(newData));
        if (location.pathname.includes(STRATEGY_ABSOLUTE_ROUTE)) {
            await dispatch(loadOneAxis(axisId));
        } else {
            await dispatch(loadProjects(currentUserId));
        }
        close()
    };

    const ProjectSchema = Yup.object().shape({
        name: Yup.string()
            .min(2, "Le nom du projet est trop court")
            .max(255, "Le nom du projet  est trop long")
            .required("Le nom du projet est obligatoire"),
        pilotId: Yup.string().required("Il est obligatoire de choisir un pilote"),
    });

    const displayModal = () => {
        return (
            <Modal>
                <Formik
                    enableReinitialize
                    initialValues={{
                        name: projectFromCoach.name,
                        referenceCode: "",
                        pilotId: "",
                        confidential: false,
                        endDate: "",
                        comment:projectFromCoach.comment
                    }}
                    validationSchema={ProjectSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isValid, isSubmitting, values, setFieldValue }) => (
                        <>
                            <Form>
                                <label htmlFor=" name"> Nom du projet * :</label>

                                <InputTextFormik
                                    name={"name"}
                                    type={"text"}
                                    placeholder={"Écrire le nom du projet"}
                                />
                                <ErrorMessage
                                    name="name"
                                    render={(msg) => (
                                        <div>
                                            <p className="error-text"> {msg} </p>
                                        </div>
                                    )}
                                />
                                <div className={"flex-col gap-05"}>
                                    <label htmlFor="comment"> Commentaire </label>
                                    <TextareaFormikInput
                                        name="comment"
                                        rows="4"
                                        placeholder="Écrivez votre commentaire"
                                    />
                                    <ErrorMessage
                                        name="comment"
                                        render={(msg) => (
                                            <div>
                                                <p className="error-text"> {msg} </p>
                                            </div>
                                        )}
                                    />
                                </div>
                                <TagInput
                                    selectedTags={selectedTags}
                                    setSelectedTags={setSelectedTags}
                                />
                                <SelectUserInputFormik
                                    pilotId={values.pilotId}
                                    users={users}
                                    name={"pilotId"}
                                />
                                <ErrorMessage
                                    name="pilotId"
                                    render={(msg) => (
                                        <div>
                                            <p className="error-text"> {msg} </p>
                                        </div>
                                    )}
                                />

                                <Date>
                                    <label htmlFor="endDate"> Échéance : </label>
                                    <Field name="endDate" type={"date"} />
                                    <ErrorMessage
                                        name="endDate"
                                        render={(msg) => (
                                            <div>
                                                <p className="error-text"> {msg} </p>
                                            </div>
                                        )}
                                    />
                                </Date>
                                <SendFormButton
                                    state={isValid && !isSubmitting}
                                    actionName={"Ajouter"}
                                />
                            </Form>
                        </>
                    )}
                </Formik>
            </Modal>
        );
    };

    return displayModal();
};

const Modal = styled.div`
  width: 100%;
  height: fit-content;
  padding: 2rem;
`;
const Date = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  white-space: nowrap;
`;

const Form = styled(FormFormik)`
  gap: 1em;
  @media (min-width: 1600px) {
    height: 100%;
  }
`;
const FirstSection = styled.div`
  display: flex;
  flex-direction: row;

  h1 {
    flex-grow: 1;
  }

  button {
    display: flex;
    align-items: flex-start;
    height: 100%;
  }
`;

export default ProjectFormForCoach;
